var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpendPeriodSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5145_24902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22L28.9657 15.0344C29.0716 14.93 29.1442 14.7965 29.1741 14.6508C29.204 14.5052 29.1899 14.3539 29.1337 14.2162C29.0774 14.0786 28.9815 13.9607 28.8581 13.8777C28.7347 13.7947 28.5894 13.7502 28.4407 13.75H15.5594C15.4107 13.7502 15.2654 13.7947 15.142 13.8777C15.0186 13.9607 14.9227 14.0786 14.8664 14.2162C14.8102 14.3539 14.7961 14.5052 14.826 14.6508C14.8559 14.7965 14.9285 14.93 15.0344 15.0344L22 22ZM22 22L28.9657 28.9656C29.0716 29.07 29.1442 29.2035 29.1741 29.3492C29.204 29.4948 29.1899 29.6461 29.1337 29.7838C29.0774 29.9214 28.9815 30.0393 28.8581 30.1223C28.7347 30.2053 28.5894 30.2498 28.4407 30.25H15.5594C15.4107 30.2498 15.2654 30.2053 15.142 30.1223C15.0186 30.0393 14.9227 29.9214 14.8664 29.7838C14.8102 29.6461 14.7961 29.4948 14.826 29.3492C14.8559 29.2035 14.9285 29.07 15.0344 28.9656L22 22ZM16.75 16.75H27.25",
    stroke: "#1B202C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5145_24902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendPeriodSquare);
export default __webpack_public_path__ + "static/media/spend-period-square.48d4e71cea7e71f110738c288d4c17a2.svg";
export { ForwardRef as ReactComponent };